<template>
    <div class="item-list" v-if="isInit">
        <div v-if="field.name" class="label-item">
            <p class="label-text">{{ field.desc }}</p>
            <el-tooltip class="item" effect="light" placement="bottom-start">
                <div slot="content">
                    - name: <strong>{{ field.name }}</strong><br/>
                    - 可以设置多项，点击 + 号新增；
                </div>
                <i class="label-icon el-icon-info"></i>
            </el-tooltip>
        </div>
        <div class="no-item" v-if="!field.def_val || !field.def_val.length">暂无内容，点击 + 号新增</div>
        <el-form ref="form" :model="field" label-width="120px">
            <draggable 
                :list="field.def_val"
                :options="draggableOpt"
                class="item-drag-area">
                <div
                    class="input-group drag-item"
                    v-for="(item, index) in field.def_val"
                    :key="index">
                    <span class="group-label">{{ `第(${index + 1})项` }}</span>
                    <el-form-item
                        class="input-row"
                        label="p1"
                        :prop="`def_val[${index}].p1`"
                        :rules="fieldRules">
                        <el-input class="field-input" v-model="item.p1" :placeholder="`请填写'${field.desc || ''}(p1)'的内容`"></el-input>
                        <renderPreview :val="item.p1"></renderPreview>
                    </el-form-item>
                    <el-form-item
                        class="input-row"
                        label="p2"
                        :prop="`def_val[${index}].p2`"
                        :rules="fieldRules">
                        <el-input class="field-input" v-model="item.p2" :placeholder="`请填写'${field.desc || ''}(p2)'的内容`"></el-input>
                        <renderPreview :val="item.p2"></renderPreview>
                    </el-form-item>
                    <el-form-item
                        class="input-row"
                        label="p3"
                        :prop="`def_val[${index}].p3`"
                        :rules="fieldRules">
                        <el-input class="field-input" v-model="item.p3" :placeholder="`请填写'${field.desc || ''}(p3)'的内容`"></el-input>
                        <renderPreview :val="item.p3"></renderPreview>
                    </el-form-item>
                    <el-form-item
                        class="input-row"
                        label="p4"
                        :prop="`def_val[${index}].p4`"
                        :rules="fieldRules">
                        <el-input class="field-input" v-model="item.p4" :placeholder="`请填写'${field.desc || ''}(p4)'的内容`"></el-input>
                        <renderPreview :val="item.p4"></renderPreview>
                    </el-form-item>
                    <el-form-item
                        class="input-row"
                        label="p5"
                        :prop="`def_val[${index}].p5`"
                        :rules="fieldRules">
                        <el-input class="field-input" v-model="item.p5" :placeholder="`请填写'${field.desc || ''}(p5)'的内容`"></el-input>
                        <renderPreview :val="item.p5"></renderPreview>
                    </el-form-item>
                    <el-button
                        class="remove-btn"
                        @click="remove(index)"
                        icon="el-icon-delete"
                        title="删除该项"></el-button>
                    <el-button
                        class="move-btn"
                        icon="el-icon-rank"
                        title="拖动此项"></el-button>
                </div>
            </draggable>
            <el-form-item>
                <el-button type="primary" class="add-btn" @click="add">+</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import moment from 'moment';
import draggable from 'vuedraggable';
import Vue from 'vue';

const renderPreview = Vue.component('render-preview', {
    functional: false,
    props: ['val'],
    methods: {
        openUrl(url) {
            window.open(url);
        }
    },
    render: function (h) {
        const { val } = this;
        let isUrl = false;
        if (/^http(s)?:\/\//.test(val)) {
            isUrl = true;
        }
        return (
            <div class="render-preview">
                {
                    isUrl ? <el-button class="render-preview-btn" icon="el-icon-view" onClick={this.openUrl.bind(this, val)}>预览</el-button> : null
                }
            </div>
        )
    }
});

export default {
    name: 'item-list',
    props: ['field', 'autoInit'],
    data() {
        return {
            fieldRules: {
                required: false,
                message: `请填写内容`,
                trigger: 'blur'
            },
            draggableOpt: {
                handle: '.move-btn',
                animation: 150
            },
            isInit: this.autoInit
        }
    },
    components: {
        draggable,
        renderPreview
    },
    watch: {
        'field'(val) {
            if (!this.field.def_val.length) {
                this.add();
            }
        }
    },
    methods: {
        initData() {
            this.isInit = true;
        },
        add() {
            this.field.def_val.push({
                p1: '',
                p2: '',
                p3: '',
                p4: '',
                p5: '',
            });
        },
        moveItemHandler(e) {
            console.log(e);
            e.stopPropagation()
        },
        remove(index) {
            this.field.def_val.splice(index, 1);
        },
        fieldBeReady() {
            // 确认组件是否就绪
            return this.$refs['form'];
        },
        getResField() {
            let isValidate = false;
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    isValidate = true;
                } else {
                    isValidate = false;
                }
            });
            if (!isValidate) {
                return;
            }
            return this.field;
        }
    },
    computed: {
    },
    mounted() {
    }
}
</script>
<style lang="less">
    @import (reference) '../../styles/public.less';
    .item-list {
        .label-item();
        .el-form-item {
            margin-bottom: 22px;
        }
        .no-item {
            text-align: center;
            line-height: 40px;
            color: #666;
        }
        .form-label {
            font-weight: 700;
            line-height: 24px;
            font-size: 14px;
        }
        .input-group {
            border-bottom: solid 1px #ddd;
            position: relative;
        }
        .field-input {
            width: 85%;
        }
        .render-preview {
            display: inline-block;
            margin-left: 10px;
            .render-preview-btn {
                padding: 12px;
                color: #20a0ff;
            }
            
        }
        .remove-btn {
            position: absolute;
            top: 40px;
            left: 0px;
            padding: 10px;
            color: red;
        }
        .move-btn {
            position: absolute;
            top: 100px;
            left: 0px;
            padding: 10px;
            margin-left: 0;
            color: #20a0ff;
        }
        .add-btn {
            margin-top: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/compEditForm/itemList.vue